import { t } from './i18n';
export function buildShareUrl(href: string, theme: string, score: number, language: string, mode: 'casual' | 'challenge' = 'casual') {
  const url = new URL(href); url.search = ''; url.hash = '';
  url.searchParams.set('theme', theme); url.searchParams.set('lang', language);
  if (mode === 'challenge') url.searchParams.set('mode', mode);
  if (Number.isSafeInteger(score) && score > 0) url.searchParams.set('target', String(score));
  return url.href;
}
export async function shareGame(url: string): Promise<'shared' | 'copied' | 'manual' | 'cancelled'> {
  if (navigator.share) {
    try { await navigator.share({ title: t('shareTitle'), text: t('shareBody'), url }); return 'shared'; }
    catch (error) { if (error instanceof DOMException && error.name === 'AbortError') return 'cancelled'; }
  }
  try { await navigator.clipboard.writeText(url); return 'copied'; } catch { return 'manual'; }
}
